import Vue from 'vue'
import Router from 'vue-router'

const main = () => import('../components/main')

// group_id: '1'
const dashboard = () => import('../views/dashboard')
// group_id: '2'
const supplier = () => import('../views/supplier')
const dock = () => import('../views/dock')
const unit = () => import('../views/unit')
const item = () => import('../views/item')
const locationLink = () => import('../views/locationLink')
const truckType = () => import('../views/truckType')
const truck = () => import('../views/truck')
const truckDetail = () => import('../views/truckDetail')
const truckPattern = () => import('../views/truckPattern')
const cycle = () => import('../views/cycle')
const cycleDetail = () => import('../views/cycleDetail')
const dayoff = () => import('../views/dayoff')
// group_id: '3'
const receive = () => import('../views/receive')
const receiveOrder = () => import('../views/receiveOrder')
const receiveOrderConfirm = () => import('../views/receiveOrderConfirm')
const receiveEdit = () => import('../views/receiveEdit')
const receiveOrderEdit = () => import('../views/receiveOrderEdit')
const receiveOrderList = () => import('../views/receiveOrderList')
const receiveOrderConfirmEdit = () => import('../views/receiveOrderConfirmEdit')
const issue = () => import('../views/issue')
const issueAdd = () => import('../views/issueAdd')
const issueEdit = () => import('../views/issueEdit')
const inspect = () => import('../views/inspect')
const inspectAdd = () => import('../views/inspectAdd')
const inspectEdit = () => import('../views/inspectEdit')
const orderRelease = () => import('../views/orderRelease')
const orderReleaseCheck = () => import('../views/orderReleaseCheck')
const orderPlan = () => import('../views/orderPlan')
const orderPlanUpload = () => import('../views/orderPlanUpload')
const confirmOrder = () => import('../views/confirmOrder')
const orderDetail = () => import('../views/orderDetail')
const deliveryPlan = () => import('../views/deliveryPlan')
const suffixSearch = () => import('../views/suffixSearch')
const kanbanSuffix = () => import('../views/kanbanSuffix')
// group_id: '4'
const adjust = () => import('../views/adjust')
const adjustAdd = () => import('../views/adjustAdd')
const kanbanAdjust = () => import('../views/kanbanAdjust')
const kanbanAdjustManage = () => import('../views/kanbanAdjustManage')
const kanbanAdjustDayoffUpload = () => import('../views/kanbanAdjustDayoffUpload')
const kanbanAdjustFactorUpload = () => import('../views/kanbanAdjustFactorUpload')
const prodSafetyFactor = () => import('../views/prodSafetyFactor')
const mrpCal = () => import('../views/mrpCal')
// group_id: '5'
const reportPartLinkage = () => import('../views/reportPartLinkage')
const reportAllPartSerial = () => import('../views/reportAllPartSerial')
const reportStockTracking = () => import('../views/reportStockTracking')
const reportInspect = () => import('../views/reportInspect')
const reportReceive = () => import('../views/reportReceive')
const reportReceiveOrder = () => import('../views/reportReceiveOrder')
const reportIssue = () => import('../views/reportIssue')
const reportStockShelfTracking = () => import('../views/reportStockShelfTracking')
const reportSummaryByPart = () => import('../views/reportSummaryByPart')
const reportStockDetailByShelf = () => import('../views/reportStockDetailByShelf')
const reportStockHistory = () => import('../views/reportStockHistory')
const reportAdjust = () => import('../views/reportAdjust')
const reportKanban = () => import('../views/reportKanban')
const reportKanbanSuffix = () => import('../views/reportKanbanSuffix')
const reportTruckMaster = () => import('../views/reportTruckMaster')
const reportMaxMin = () => import('../views/reportMaxMin')
// group_id: '6'
const calendarPattern = () => import('../views/calendarPattern')
const config = () => import('../views/config')
const user = () => import('../views/user')
const permission = () => import('../views/permission')
// group_id: '7'
const logLogin = () => import('../views/logLogin')
const logConfig = () => import('../views/logConfig')
const logAdjust = () => import('../views/logAdjust')
const logCalendar = () => import('../views/logCalendar')
const logDock = () => import('../views/logDock')
const logInspect = () => import('../views/logInspect')
const logIssue = () => import('../views/logIssue')
const logLocationLinkage = () => import('../views/logLocationLinkage')
const logPart = () => import('../views/logPart')
const logPartStore = () => import('../views/logPartStore')
const logReceive = () => import('../views/logReceive')
const logSupplier = () => import('../views/logSupplier')
const logUser = () => import('../views/logUser')
const logPsf = () => import('../views/logPsf')
const logMrp = () => import('../views/logMrp')
const logKanbanAdjust = () => import('../views/logKanbanAdjust')
const logFifo = () => import('../views/logFifo')
// group_id: '8'
const scanRoutine = () => import('../views/scanRoutine')
const scanPhysical = () => import('../views/scanPhysical')
const packaging = () => import('../views/packaging')
const packagingNonMovement = () => import('../views/packagingNonMovement')
const scanReport = () => import('../views/scanReport')
const writeOffReport = () => import('../views/writeOffReport')
const writeOffInput = () => import('../views/writeOffInput')
const scanWriteoff = () => import('../views/scanWriteoff')
const scanReborn = () => import('../views/scanReborn')
const manualWriteoff = () => import('../views/manualWriteoff')
const manualReborn = () => import('../views/manualReborn')
// group_id: '9'
const packingstockout = () => import('../views/packingstockout')
const packingstockoutAdd = () => import('../views/packingstockoutAdd')
const packingstockoutEdit = () => import('../views/packingstockoutEdit')
const packingList = () => import('../views/packingtwobin')
const packingtwobinAdd = () => import('../views/packingtwobinAdd')
const packingpassthroughAdd = () => import('../views/packingpassthroughAdd')
const packingtwobinDetail = () => import('../views/packingtwobinDetail')
const packingpassthroughDetail = () => import('../views/packingpassthroughDetail')
const packingservicepartDetail = () => import('../views/packingservicepartDetail')
const packingservicepartAdd = () => import('../views/packingservicepartAdd')
const packingbox = () => import('../views/packingbox')
const packingstore = () => import('../views/packingstore')
const packingPlan = () => import('../views/packingPlan')
const dummy = () => import('../views/dummy')
// group_id: '10'
const reportPackingStockBalance = () => import('../views/reportPackingStockBalance')
const reportPackingSerial = () => import('../views/reportPackingSerial')
const reportPackingStock = () => import('../views/reportPackingStock')
const reportPacking = () => import('../views/reportPacking')
// group_id: '11'
const agvSetup = () => import('../views/agvSetup')
const agvSetupImport = () => import('../views/agvSetupImport')
const agvVehicle = () => import('../views/agvVehicle')
const agvOrder = () => import('../views/agvOrder')
const agvOrderList = () => import('../views/agvOrderList')
const agvReceive = () => import('../views/agvReceive')
const agvShop = () => import('../views/agvShop')
const agvLog = () => import('../views/agvLog')
const agvBoard = () => import('../views/agvBoard')
const agvOrderReport = () => import('../views/agvOrderReport')
// group_id: ''
const login = () => import('../views/login')
const wait = () => import('../components/wait')
const error404 = () => import('../components/404')
Vue.use(Router)
const titlename = ' | AGcaddy'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'wait',
      component: wait,
      meta: { title: 'Waiting', title_sub: '', group_id: 0, menu_id: 0 }
    },
    {
      path: '',
      name: 'main',
      component: main,
      children: [
        // group_id: '1'
        {
          path: '/dashboard',
          name: 'dashboard',
          component: dashboard,
          meta: { title: 'Dashboard', title_sub: '', group_id: '1', menu_id: '1' }
        },
        // group_id: '2'
        {
          path: '/supplier',
          name: 'supplier',
          component: supplier,
          meta: { title: 'Supplier', title_sub: '', group_id: '2', menu_id: '19' }
        },
        {
          path: '/dock',
          name: 'dock',
          component: dock,
          meta: { title: 'Dock', title_sub: '', group_id: '2', menu_id: '20' }
        },
        {
          path: '/unit',
          name: 'unit',
          component: unit,
          meta: { title: 'Unit', title_sub: '', group_id: '2', menu_id: '3' }
        },
        {
          path: '/item',
          name: 'item',
          component: item,
          meta: { title: 'Part', title_sub: '', group_id: '2', menu_id: '2' }
        },
        {
          path: '/locationlink',
          name: 'locationLink',
          component: locationLink,
          meta: { title: 'Shelf Location', title_sub: '', group_id: '2', menu_id: '21' }
        },
        {
          path: '/trucktype',
          name: 'truckType',
          component: truckType,
          meta: { title: 'Truck Type', title_sub: '', group_id: '2', menu_id: '54' }
        },
        {
          path: '/truck',
          name: 'truck',
          component: truck,
          meta: { title: 'Truck Master', title_sub: '', group_id: '2', menu_id: '8' }
        },
        {
          path: '/truckdetail',
          name: 'truckDetail',
          component: truckDetail,
          meta: { title: 'Truck Pattern', title_sub: '', group_id: '2', menu_id: '8' }
        },
        {
          path: '/truckpattern',
          name: 'truckPattern',
          component: truckPattern,
          meta: { title: 'Truck Calendar', title_sub: '', group_id: '2', menu_id: '8' }
        },
        {
          path: '/cycle',
          name: 'cycle',
          component: cycle,
          meta: { title: 'Cycle Registration', title_sub: '', group_id: '2', menu_id: '28' }
        },
        {
          path: '/cycledetail',
          name: 'cycleDetail',
          component: cycleDetail,
          meta: { title: 'Cycle Registration', title_sub: '', group_id: '2', menu_id: '28' }
        },
        {
          path: '/dayoff',
          name: 'dayoff',
          component: dayoff,
          meta: { title: 'Calendar', title_sub: '', group_id: '2', menu_id: '46' }
        },
        // group_id: '3'
        {
          path: '/receive',
          name: 'receive',
          component: receive,
          meta: { title: 'Stock In', title_sub: '', group_id: '3', menu_id: '4' }
        },
        {
          path: '/receiveorder',
          name: 'receiveOrder',
          component: receiveOrder,
          meta: { title: 'Stock In Order', title_sub: '', group_id: '3', menu_id: '60' }
        },
        {
          path: '/receiveorderconfirm',
          name: 'receiveOrderConfirm',
          component: receiveOrderConfirm,
          meta: { title: 'Stock In Confirm', title_sub: '', group_id: '3', menu_id: '62' }
        },
        {
          path: '/receiveedit',
          name: 'receiveEdit',
          component: receiveEdit,
          meta: { title: 'Stock In Edit', title_sub: '', group_id: '3', menu_id: '4' }
        },
        {
          path: '/receiveorderedit',
          name: 'receiveOrderEdit',
          component: receiveOrderEdit,
          meta: { title: 'Stock In Order Edit', title_sub: '', group_id: '3', menu_id: '60' }
        },
        {
          path: '/receiveorderconfirmedit',
          name: 'receiveOrderConfirmEdit',
          component: receiveOrderConfirmEdit,
          meta: { title: 'Stock In Confirm Edit', title_sub: '', group_id: '3', menu_id: '62' }
        },
        {
          path: '/receiveorderlist',
          name: 'receiveOrderList',
          component: receiveOrderList,
          meta: { title: 'Stock In Order List', title_sub: '', group_id: '3', menu_id: '60' }
        },
        {
          path: '/issue',
          name: 'issue',
          component: issue,
          meta: { title: 'Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
        },
        {
          path: '/issueadd',
          name: 'issueAdd',
          component: issueAdd,
          meta: { title: 'Add Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
        },
        {
          path: '/issueedit',
          name: 'issueEdit',
          component: issueEdit,
          meta: { title: 'Edit Stock Out', title_sub: '', group_id: '3', menu_id: '5' }
        },
        {
          path: '/inspect',
          name: 'inspect',
          component: inspect,
          meta: { title: 'Stock Taking', title_sub: '', group_id: '3', menu_id: '6' }
        },
        {
          path: '/inspectadd',
          name: 'inspectAdd',
          component: inspectAdd,
          meta: { title: 'Stock Taking Add', title_sub: '', group_id: '3', menu_id: '6' }
        },
        {
          path: '/inspect/:id',
          name: 'inspectEdit',
          component: inspectEdit,
          meta: { title: 'Stock Taking Edit', title_sub: '', group_id: '3', menu_id: '6' }
        },
        {
          path: '/orderrelease',
          name: 'orderRelease',
          component: orderRelease,
          meta: { title: 'Order Release', title_sub: '', group_id: '3', menu_id: '53' }
        },
        {
          path: '/orderreleasecheck',
          name: 'orderReleaseCheck',
          component: orderReleaseCheck,
          meta: { title: 'Order Release Check', title_sub: '', group_id: '3', menu_id: '53' }
        },
        {
          path: '/orderplan',
          name: 'orderPlan',
          component: orderPlan,
          meta: { title: 'Order Plan', title_sub: '', group_id: '3', menu_id: '66' }
        },
        {
          path: '/orderplanupload',
          name: 'orderPlanUpload',
          component: orderPlanUpload,
          meta: { title: 'Order Plan Upload', title_sub: '', group_id: '3', menu_id: '66' }
        },
        {
          path: '/suffixsearch',
          name: 'suffixSearch',
          component: suffixSearch,
          meta: { title: 'Kanban Suffix Search', title_sub: '', group_id: '3', menu_id: '64' }
        },
        {
          path: '/kanbansuffix',
          name: 'kanbanSuffix',
          component: kanbanSuffix,
          meta: { title: 'Kanban Suffix Search', title_sub: '', group_id: '3', menu_id: '64' }
        },
        {
          path: '/confirmorder',
          name: 'confirmOrder',
          component: confirmOrder,
          meta: { title: 'Confirmation Order', title_sub: '', group_id: '3', menu_id: '55' }
        },
        {
          path: '/orderdetail',
          name: 'orderDetail',
          component: orderDetail,
          meta: { title: 'Order Detail', title_sub: '', group_id: '3', menu_id: '55' }
        },
        {
          path: '/deliveryplan',
          name: 'deliveryPlan',
          component: deliveryPlan,
          meta: { title: 'Delivery Plan', title_sub: '', group_id: '3', menu_id: '55' }
        },
        // group_id: '4'
        {
          path: '/adjust',
          name: 'adjust',
          component: adjust,
          meta: { title: 'Adjust Stock', title_sub: '', group_id: '4', menu_id: '7' }
        },
        {
          path: '/adjustadd',
          name: 'adjustAdd',
          component: adjustAdd,
          meta: { title: 'Add Adjust Stock', title_sub: '', group_id: '4', menu_id: '7' }
        },
        {
          path: '/kanbanadjust',
          name: 'kanbanAdjust',
          component: kanbanAdjust,
          meta: { title: 'Kanban Adjust', title_sub: '', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustmanage/:ps_id',
          name: 'kanbanAdjustManage',
          component: kanbanAdjustManage,
          meta: { title: 'Kanban Adjust Manage', title_sub: '', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustdayoffupload',
          name: 'kanbanAdjustDayoffUpload',
          component: kanbanAdjustDayoffUpload,
          meta: { title: 'Kanban Adjust Dayoff Upload', title_sub: '', group_id: '4', menu_id: '56' }
        },
        {
          path: '/kanbanadjustfactorupload',
          name: 'kanbanAdjustFactorUpload',
          component: kanbanAdjustFactorUpload,
          meta: { title: 'Kanban Adjust Factor Upload', title_sub: '', group_id: '4', menu_id: '56' }
        },
        {
          path: '/prodsafetyfactor',
          name: 'prodSafetyFactor',
          component: prodSafetyFactor,
          meta: { title: 'Prod & Safety Factor', title_sub: '', group_id: '4', menu_id: '29' }
        },
        {
          path: '/mrp',
          name: 'mrpCal',
          component: mrpCal,
          meta: { title: 'MRP Cal', title_sub: '', group_id: '4', menu_id: '30' }
        },
        // group_id: '5'
        {
          path: '/reportreceive',
          name: 'reportReceive',
          component: reportReceive,
          meta: { title: 'Report Stock In', title_sub: '', group_id: '5', menu_id: '9' }
        },
        {
          path: '/reportreceiveorder',
          name: 'reportReceiveOrder',
          component: reportReceiveOrder,
          meta: { title: 'Report Stock In Order', title_sub: '', group_id: '5', menu_id: '61' }
        },
        {
          path: '/reportissue',
          name: 'reportIssue',
          component: reportIssue,
          meta: { title: 'Report Stock Out', title_sub: '', group_id: '5', menu_id: '10' }
        },
        {
          path: '/reportinspect',
          name: 'reportInspect',
          component: reportInspect,
          meta: { title: 'Report Inspect', title_sub: '', group_id: '5', menu_id: '11' }
        },
        {
          path: '/reportpartlinkage',
          name: 'reportPartLinkage',
          component: reportPartLinkage,
          meta: { title: 'Report Part Linkage', title_sub: '', group_id: '5', menu_id: '22' }
        },
        {
          path: '/reportallpartserial',
          name: 'reportAllPartSerial',
          component: reportAllPartSerial,
          meta: { title: 'Report Serial', title_sub: '', group_id: '5', menu_id: '59' }
        },
        {
          path: '/reportstocktracking',
          name: 'reportStockTracking',
          component: reportStockTracking,
          meta: { title: 'Report Balance Stock', title_sub: '', group_id: '5', menu_id: '23' }
        },
        {
          path: '/reportstockshelftracking',
          name: 'reportStockShelfTracking',
          component: reportStockShelfTracking,
          meta: { title: 'Report Balance Stock', title_sub: '', group_id: '5', menu_id: '24' }
        },
        {
          path: '/reportstockhistory',
          name: 'reportStockHistory',
          component: reportStockHistory,
          meta: { title: 'Report History Stock Taking By Part', title_sub: '', group_id: '5', menu_id: '25' }
        },
        {
          path: '/reportsummarybypart',
          name: 'reportSummaryByPart',
          component: reportSummaryByPart,
          meta: { title: 'Report Summary By Part', title_sub: '', group_id: '5', menu_id: '26' }
        },
        {
          path: '/reportstockdetailbyshelf',
          name: 'reportStockDetailByShelf',
          component: reportStockDetailByShelf,
          meta: { title: 'Report Stock Detail By Shelf', title_sub: '', group_id: '5', menu_id: '27' }
        },
        {
          path: '/reporttruckmaster',
          name: 'reportTruckMaster',
          component: reportTruckMaster,
          meta: { title: 'Report Truck Master', title_sub: '', group_id: '5', menu_id: '52' }
        },
        {
          path: '/reportmaxmin',
          name: 'reportMaxMin',
          component: reportMaxMin,
          meta: { title: 'Report Kanban Setup', title_sub: '', group_id: '5', menu_id: '32' }
        },
        {
          path: '/reportadjust',
          name: 'reportAdjust',
          component: reportAdjust,
          meta: { title: 'Report Adjust', title_sub: '', group_id: '5', menu_id: '12' }
        },
        {
          path: '/reportkanban',
          name: 'reportKanban',
          component: reportKanban,
          meta: { title: 'Report Kanban Adjust', title_sub: '', group_id: '5', menu_id: '57' }
        },
        {
          path: '/reportkanbansuffix',
          name: 'reportKanbanSuffix',
          component: reportKanbanSuffix,
          meta: { title: 'Report Kanban Suffix', title_sub: '', group_id: '5', menu_id: '65' }
        },
        // group_id: '6'
        {
          path: '/calendarpattern',
          name: 'calendarPattern',
          component: calendarPattern,
          meta: { title: 'Calendar Pattern', title_sub: '', group_id: '6', menu_id: '47' }
        },
        {
          path: '/config',
          name: 'config',
          component: config,
          meta: { title: 'Config', title_sub: '', group_id: '6', menu_id: '14' }
        },
        {
          path: '/user',
          name: 'user',
          component: user,
          meta: { title: 'User', title_sub: '', group_id: '6', menu_id: '15' }
        },
        {
          path: '/permission',
          name: 'permission',
          component: permission,
          meta: { title: 'Permission', title_sub: '', group_id: '6', menu_id: '16' }
        },
        // group_id: '7'
        {
          path: '/loglogin',
          name: 'logLogin',
          component: logLogin,
          meta: { title: 'Log Login', title_sub: '', group_id: '7', menu_id: '17' }
        },
        {
          path: '/logconfig',
          name: 'logConfig',
          component: logConfig,
          meta: { title: 'Log Config', title_sub: '', group_id: '7', menu_id: '18' }
        },

        {
          path: '/loguser',
          name: 'logUser',
          component: logUser,
          meta: { title: 'Log User', title_sub: '', group_id: '7', menu_id: '43' }
        },
        {
          path: '/logadjust',
          name: 'logAdjust',
          component: logAdjust,
          meta: { title: 'Log Adjust', title_sub: '', group_id: '7', menu_id: '33' }
        },
        {
          path: '/logcalendar',
          name: 'logCalendar',
          component: logCalendar,
          meta: { title: 'Log Calendar', title_sub: '', group_id: '7', menu_id: '34' }
        },
        {
          path: '/logdock',
          name: 'logDock',
          component: logDock,
          meta: { title: 'Log Dock', title_sub: '', group_id: '7', menu_id: '35' }
        },
        {
          path: '/loginspect',
          name: 'logInspect',
          component: logInspect,
          meta: { title: 'Log Inspect', title_sub: '', group_id: '7', menu_id: '36' }
        },
        {
          path: '/logissue',
          name: 'logIssue',
          component: logIssue,
          meta: { title: 'Log Issue', title_sub: '', group_id: '7', menu_id: '37' }
        },
        {
          path: '/loglocationlinkage',
          name: 'logLocationLinkage',
          component: logLocationLinkage,
          meta: { title: 'Log Location Linkage', title_sub: '', group_id: '7', menu_id: '38' }
        },
        {
          path: '/logpart',
          name: 'logPart',
          component: logPart,
          meta: { title: 'Log Part', title_sub: '', group_id: '7', menu_id: '39' }
        },
        {
          path: '/logpartstore',
          name: 'logPartStore',
          component: logPartStore,
          meta: { title: 'Log Part Store', title_sub: '', group_id: '7', menu_id: '40' }
        },
        {
          path: '/logreceive',
          name: 'logReceive',
          component: logReceive,
          meta: { title: 'Log Receive', title_sub: '', group_id: '7', menu_id: '41' }
        },
        {
          path: '/logsupplier',
          name: 'logSupplier',
          component: logSupplier,
          meta: { title: 'Log Supplier', title_sub: '', group_id: '7', menu_id: '42' }
        },
        {
          path: '/logpsf',
          name: 'logPsf',
          component: logPsf,
          meta: { title: 'Log Prod & Safety Factor', title_sub: '', group_id: '7', menu_id: '50' }
        },
        {
          path: '/logmrp',
          name: 'logMrp',
          component: logMrp,
          meta: { title: 'Log MRP Cal', title_sub: '', group_id: '7', menu_id: '51' }
        },
        {
          path: '/logkanbanadjust',
          name: 'logKanbanAdjust',
          component: logKanbanAdjust,
          meta: { title: 'Log Kanban Adjust', title_sub: '', group_id: '7', menu_id: '58' }
        },
        {
          path: '/logfifo',
          name: 'logFifo',
          component: logFifo,
          meta: { title: 'Log FIFO Override', title_sub: '', group_id: '7', menu_id: '73' }
        },
        // group_id: '8'
        {
          path: '/scanroutine',
          name: 'scanRoutine',
          component: scanRoutine,
          meta: { title: 'Packaging', title_sub: 'Routine Scanning', group_id: '8', menu_id: '68' }
        },
        {
          path: '/scanphysical',
          name: 'scanPhysical',
          component: scanPhysical,
          meta: { title: 'Packaging', title_sub: 'Physical Scanning', group_id: '8', menu_id: '69' }
        },
        {
          path: '/packaging',
          name: 'packaging',
          component: packaging,
          meta: { title: 'Packaging', title_sub: 'Packaging List Master', group_id: '8', menu_id: '67' }
        },
        {
          path: '/nonmovement',
          name: 'nonMovement',
          component: packagingNonMovement,
          meta: { title: 'Packaging', title_sub: 'Non Movement Alert', group_id: '8', menu_id: '70' }
        },
        {
          path: '/scanreport',
          name: 'scanReport',
          component: scanReport,
          meta: { title: 'Packaging', title_sub: 'Scanning Result Report', group_id: '8', menu_id: '71' }
        },
        {
          path: '/writeoffreport',
          name: 'writeOffReport',
          component: writeOffReport,
          meta: { title: 'Packaging', title_sub: 'Write Off Report', group_id: '8', menu_id: '72' }
        },
        {
          path: '/writeoffinput',
          name: 'writeOffInput',
          component: writeOffInput,
          meta: { title: 'Packaging', title_sub: 'Write Off Input', group_id: '8', menu_id: '74' }
        },
        {
          path: '/scanwriteoff',
          name: 'scanWriteoff',
          component: scanWriteoff,
          meta: { title: 'Packaging', title_sub: 'Scanning Write-Off', group_id: '8', menu_id: '74' }
        },
        {
          path: '/scanreborn',
          name: 'scanReborn',
          component: scanReborn,
          meta: { title: 'Packaging', title_sub: 'Scanning Reborn', group_id: '8', menu_id: '74' }
        },
        {
          path: '/manualwriteoff',
          name: 'manualWriteoff',
          component: manualWriteoff,
          meta: { title: 'Packaging', title_sub: 'Manual Write-Off', group_id: '8', menu_id: '74' }
        },
        {
          path: '/manualreborn',
          name: 'manualReborn',
          component: manualReborn,
          meta: { title: 'Packaging', title_sub: 'Manual Reborn', group_id: '8', menu_id: '74' }
        },
        // group_id: '9'
        {
          path: '/packingstockout',
          name: 'packingstockout',
          component: packingstockout,
          meta: { title: 'Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
        },
        {
          path: '/packingstockoutadd',
          name: 'packingstockoutAdd',
          component: packingstockoutAdd,
          meta: { title: 'Add Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
        },
        {
          path: '/packingstockoutedit',
          name: 'packingstockoutEdit',
          component: packingstockoutEdit,
          meta: { title: 'Edit Packing Stock Out', title_sub: '', group_id: '9', menu_id: '79' }
        },
        {
          path: '/packinglist',
          name: 'packingList',
          component: packingList,
          meta: { title: 'Packing List', title_sub: '', group_id: '9', menu_id: '77' }
        },
        {
          path: '/packingtwobinadd',
          name: 'packingtwobinAdd',
          component: packingtwobinAdd,
          meta: { title: 'Add Packing 2Bin', title_sub: '', group_id: '9', menu_id: '76' }
        },
        {
          path: '/packingpassthroughadd',
          name: 'packingpassthroughAdd',
          component: packingpassthroughAdd,
          meta: { title: 'Add Packing Pass Through', title_sub: '', group_id: '9', menu_id: '84' }
        },
        {
          path: '/packingservicepartadd',
          name: 'packingservicepartAdd',
          component: packingservicepartAdd,
          meta: { title: 'Add Packing Service Part', title_sub: '', group_id: '9', menu_id: '78' }
        },
        {
          path: '/packingtwobindetail/:pk_id',
          name: 'packingtwobinDetail',
          component: packingtwobinDetail,
          meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '76' }
        },
        {
          path: '/packingpassthroughdetail/:pk_id',
          name: 'packingpassthroughDetail',
          component: packingpassthroughDetail,
          meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '84' }
        },
        {
          path: '/packingservicepartdetail/:pk_id',
          name: 'packingservicepartDetail',
          component: packingservicepartDetail,
          meta: { title: 'Packing Detail', title_sub: '', group_id: '9', menu_id: '78' }
        },
        {
          path: '/packingbox',
          name: 'packingbox',
          component: packingbox,
          meta: { title: 'Packing Box List', title_sub: '', group_id: '9', menu_id: '80' }
        },
        {
          path: '/packingstore',
          name: 'packingstore',
          component: packingstore,
          meta: { title: 'Packing List Master', title_sub: '', group_id: '9', menu_id: '75' }
        },
        {
          path: '/dummy',
          name: 'Dummy Serial',
          component: dummy,
          meta: { title: 'Dummy Serial', title_sub: '', group_id: '9', menu_id: '75' }
        },
        {
          path: '/packingplan',
          name: 'packingplan',
          component: packingPlan,
          meta: { title: 'Packing Plan', title_sub: '', group_id: '9', menu_id: '95' }
        },
        // group_id: '10'
        {
          path: '/reportpackingstockbalance',
          name: 'reportpackingstockbalance',
          component: reportPackingStockBalance,
          meta: { title: 'Report Packing Stock Balance', title_sub: '', group_id: '10', menu_id: '81' }
        },
        {
          path: '/reportpackingserial',
          name: 'reportpackingserial',
          component: reportPackingSerial,
          meta: { title: 'Report Packing Serial', title_sub: '', group_id: '10', menu_id: '82' }
        },
        {
          path: '/reportpackingstock',
          name: 'reportpackingstock',
          component: reportPackingStock,
          meta: { title: 'Report Packing Stock', title_sub: '', group_id: '10', menu_id: '83' }
        },
        {
          path: '/reportpacking',
          name: 'reportpacking',
          component: reportPacking,
          meta: { title: 'Report Packing', title_sub: '', group_id: '10', menu_id: '85' }
        },
        // group_id: '11'
        {
          path: '/agvsetup',
          name: 'agvSetup',
          component: agvSetup,
          meta: { title: 'AGV Setup', title_sub: '', group_id: '11', menu_id: '92' }
        },
        {
          path: '/agvsetupimport',
          name: 'agvsetupimport',
          component: agvSetupImport,
          meta: { title: 'AGV Setup Import', title_sub: '', group_id: '11', menu_id: '94' }
        },
        {
          path: '/agvvehicle',
          name: 'agvVehicle',
          component: agvVehicle,
          meta: { title: 'AGV Vehicle', title_sub: '', group_id: '11', menu_id: '86' }
        },
        {
          path: '/agvorder',
          name: 'agvOrder',
          component: agvOrder,
          meta: { title: 'AGV Order', title_sub: '', group_id: '11', menu_id: '87' }
        },
        {
          path: '/agvorderlist',
          name: 'agvOrderList',
          component: agvOrderList,
          meta: { title: 'AGV Order List', title_sub: '', group_id: '11', menu_id: '87' }
        },
        {
          path: '/agvreceive',
          name: 'agvReceive',
          component: agvReceive,
          meta: { title: 'AGV Receive', title_sub: '', group_id: '11', menu_id: '87' }
        },
        {
          path: '/agvshop',
          name: 'agvShop',
          component: agvShop,
          meta: { title: 'AGV Shop', title_sub: '', group_id: '11', menu_id: '88' }
        },
        {
          path: '/agvlog',
          name: 'agvLog',
          component: agvLog,
          meta: { title: 'AGV Log', title_sub: '', group_id: '11', menu_id: '89' }
        },
        {
          path: '/agvboard',
          name: 'agvBoard',
          component: agvBoard,
          meta: { title: 'AGV Board', title_sub: '', group_id: '11', menu_id: '91' }
        },
        {
          path: '/agvorderreport',
          name: 'agvOrderReport',
          component: agvOrderReport,
          meta: { title: 'AGV Order Report', title_sub: '', group_id: '11', menu_id: '93' }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { title: 'Login', title_sub: '' }
    },
    {
      path: '*',
      name: 'P404',
      component: error404,
      meta: { title: 'Error Page', title_sub: '' }
    }
  ]
})
const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title !== '' ? to.meta.title + titlename : to.meta.title_sub + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js